import i18next from "../../../i18n";

i18next.addResourceBundle("en", "Tag", {
    textDone: "Done",
    textValidated: "Validated",
    textInProgress: "In progress",
    textAnswered: "Answered",
    textSuggestion: "Suggestion",
});
